import React from 'react';
import { withRouter } from 'react-router-dom';

import { SomaIcon } from "@soma/react";

import { Text } from 'xpi-black-ui/Base/Typography';

import Row from './styles';
import { Props, DefaultProps } from './shape';

export const GoBack = (props) => {
  const { link, history } = props;

  const onClickBack = () => {
    if (link) {
      history.push(link);
    } else {
      history.goBack();
    }
  };

  return (
    <Row onClick={() => onClickBack()}>
      <SomaIcon size="sm" icon="arrow-left" color="#838488" />
      <Text secondary>Voltar</Text>
    </Row>
  );
};

GoBack.defaultProps = DefaultProps;
GoBack.propTypes = Props;

export default withRouter(GoBack);
